import { z } from "zod"

export enum StandardOfferingType {
  BOOKABLE_SERVICE = "BOOKABLE_SERVICE",
  BOOKABLE_SERVICE_EXTERNAL = "BOOKABLE_SERVICE_EXTERNAL",
  DROP_IN_SERVICE = "DROP_IN_SERVICE",
  DAMPER_SERVICE = "DAMPER_SERVICE",
  EBIKE_SERVICE = "EBIKE_SERVICE",
  LOAN_BIKE_DURING_SERVICE = "LOAN_BIKE_DURING_SERVICE",
  BIKE_GARAGE = "BIKE_GARAGE",
  SELLING_BIKES = "SELLING_BIKES",
  RENTING_OUT_BIKES = "RENTING_OUT_BIKES",
  SELLING_ACCESSORIES = "SELLING_ACCESSORIES",
  FREE_TIRE_INFLATION = "FREE_TIRE_INFLATION",
  PHONE_BOOKING = "PHONE_BOOKING",
  EMAIL_BOOKING = "EMAIL_BOOKING",
}

export const StandardOfferingSchema = z.object({
  id: z.string().uuid(),
  type: z.nativeEnum(StandardOfferingType),
  externalBookingUrl: z.string().nullable(),
})

export const CreateStandardOfferingSchema = z.object({
  type: z.nativeEnum(StandardOfferingType),
  externalBookingUrl: z.string().url().nullable().optional(),
})

export type StandardOffering = z.infer<typeof StandardOfferingSchema>
export type CreateStandardOffering = z.infer<
  typeof CreateStandardOfferingSchema
>
